export type OffsetDateTime = string;
export const offsetDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSZ';
